export { ComponentLoader } from './component-loader.class';
export { ComponentLoaderFactory } from './component-loader.factory';
export { ContentRef } from './content-ref.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/component-loader/index.js
// module id = 82
// module chunks = 7